export default function setSentryContext() {
  const sentryEnabled = process.env.SENTRY_ENABLED === 'true';
  if (!sentryEnabled) { return; }

  const userId = analyticsDataLayer.customerId; // account_id
  const userEmail = analyticsDataLayer.user_email;
  const overlaysVersion = analyticsDataLayer.overlays_version;
  const regFlow = analyticsDataLayer.registration_flow;
  const additionalContext = {
    overlays_version: overlaysVersion,
  };
  const extraContext = {
    ...analyticsDataLayer,
    ...additionalContext,
  };

  try {
    Sentry.configureScope((scope) => {
      Object.entries(extraContext).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
      scope.setUser({
        email: userEmail,
        id:    userId,
      });
      scope.setTag('which_sentry', 'vue');
      scope.setTag('reg_flow', regFlow);
    });
  } catch {
    // proceed without additional information
  }
}
